module.exports = __webpack_public_path__ + "static/media/de01.c7f7ae56.jpg";